import store from '@/store.js'
import axios from 'axios'

export default {

    verifyUserRole: function (roleToCheck) {
        return new Promise((resolve, reject) => {
            axios.get(store.state.mainAppURL + "users/get_user_roles").then(allRoles => {
                for (let role of allRoles.data) {
                    if (role.role === roleToCheck) {
                        resolve(true);
                    }
                }
                reject(false);
            });
        });

    },

    fetchUserRoles: function () {
        return new Promise((resolve) => {
            axios.get(store.state.mainAppURL + "users/get_user_roles").then(allRoles => {
                resolve(allRoles.data[0].role);
            });
        });
    }

}
